import ReactDOM from 'react-dom/client';

import App from './app/App';
import { captureInstallPrompt, registerServiceWorker } from './shared/lib/pwa';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <App />
);

// Outside React on purpose. `beforeinstallprompt` is fired once and never replayed, so a
// listener attached in a component effect would miss an event that arrives while the login
// page is still mounting — and the Android install button would silently never appear.
// Neither of these needs the router or the query client, so neither belongs in a provider.
captureInstallPrompt();
registerServiceWorker();
